import React from 'react';
import { createPortal } from 'react-dom';
import { Loader as LoaderIcon } from 'lucide-react';
import PropTypes from 'prop-types';
import './loader.css';

function Loader({ size = 40, fullScreen = true }) {
  const content = (
    <div className={fullScreen ? 'loader-overlay' : ''}>
      <LoaderIcon className="spinner" size={size} />
    </div>
  );

  if (fullScreen && typeof document !== 'undefined') {
    return createPortal(content, document.body);
  }

  return content;
}

Loader.propTypes = {
  size: PropTypes.number,
  fullScreen: PropTypes.bool,
};

export default Loader;
